import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const ComponentWrapper = styled('div', {
    isDisabled: Boolean,
    customStyle: Array,
})`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 11px 16px;
    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg.calendar-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }

            svg.info-line-icon {
            }

            h1 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 6px;
            }
        }
    }

    .calender-wrapper {
        ${FLEX_CENTER}
        justify-content: space-between;
        margin-top: 16px;
        background-color: ${({ isDisabled }) =>
            isDisabled ? GRAY(10) : '#fff'};
        border-radius: 2px;
        border: 1px solid ${GRAY(30)};
        width: 100%;
        padding: 7px;
        color: ${({ isDisabled }) => (isDisabled ? GRAY(50) : GRAY(100))};
        cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
        height: 34px;

        &.has-comparison {
            height: 48px;
        }

        .period-text-wrapper {
            cursor: ${({ isDisabled }) =>
                isDisabled ? 'not-allowed' : 'pointer'};

            .period-text {
                font-size: 13px;
            }
        }
        .arrow-wrapper {
            ${FLEX_CENTER}
            svg {
                width: 14px;
            }
        }
    }

    ${({ customStyle }) => customStyle}
`;

export const RangeWrapper = styled(FLEX_COLUMN_DIV)`
    gap: 5px;
`;

export const DateWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 10px;
`;

export const Pointer = styled('span', { color: String })`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: ${({ color }) => color};
`;
